var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add_new_item",on:{"click":_vm.goToNew}},[_c('iconEvalNew')],1)}
var staticRenderFns = []

export { render, staticRenderFns }